import { QuestionPlanIsHiddenHotelQuestions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/is-hidden-hotel-questions";

import { useDayTripPlanIsHiddenHotelQuestions } from "./hooks";

export const QuestionDayTripPlanIsHiddenHotelQuestions = () => {
	const { questions, isHiddenHotelQuestions, onSetIsHiddenHotelQuestions } = useDayTripPlanIsHiddenHotelQuestions();

	return (
		<Question
			questions={questions}
			isHiddenHotelQuestions={isHiddenHotelQuestions}
			onSetIsHiddenHotelQuestions={onSetIsHiddenHotelQuestions}
		/>
	);
};

QuestionDayTripPlanIsHiddenHotelQuestions.displayName = "QuestionDayTripPlanIsHiddenHotelQuestions";
